"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _SM = _interopRequireDefault(require("../Icons/AngleLeft/SM"));
var _SM2 = _interopRequireDefault(require("../Icons/AngleRight/SM"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["classes", "className", "direction", "orientation", "disabled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _createStyles.createStyles)({
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: '100%',
    height: 40,
    '& svg': {
      transform: 'rotate(90deg)'
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {
    opacity: 0
  }
});

/**
 * A TabScrollButton is used to scroll the Tabs when they are not all visible.
 */
const TabScrollButton = /*#__PURE__*/React.forwardRef(function TabScrollButton(props, ref) {
  const {
      classes: classesOverrides,
      className: classNameProp,
      direction,
      orientation,
      disabled
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
    component: "div",
    className: cx(classes.root, {
      [classes.vertical]: orientation === 'vertical',
      [classes.disabled]: disabled
    }, classNameProp),
    ref: ref,
    "data-testid": `scroll-button-${direction}`
  }, other), direction === 'left' ? /*#__PURE__*/React.createElement(_SM.default, null) : /*#__PURE__*/React.createElement(_SM2.default, null));
});
var _default = exports.default = TabScrollButton;